import styled from 'styled-components';
import { colorUsage } from 'stylesheet';
export var OptionLabel = styled.span.withConfig({
  displayName: "TagAutocompleteOptionstyle__OptionLabel",
  componentId: "sc-na3lq2-0"
})(["color:", ";"], function (props) {
  return props.highlighted ? colorUsage.tagInput.options.highlight[props.multiple ? 'multiple' : 'default'].color : 'inherit';
});